<!-- src/components/device/commands/GnssCard.vue -->
<!-- Position GPS — partagé admin/client : activation et intervalle entre deux relevés. -->
<template>
  <div class="bg-white rounded-lg shadow p-4">
    <h3 class="font-semibold text-gray-800">
      {{ $t('gnss.titre') }}
      <span v-if="technique" class="ml-1 text-xs font-normal text-gray-400">GNSS</span>
    </h3>
    <p class="mt-1 text-sm text-gray-500">
      {{ $t('gnss.intro') }}
    </p>
    <!-- Règle des réglages à deux états : voir ChoixBinaire.vue. L'état est aussi écrit en
         toutes lettres, la carte GPS n'ayant pas de question pour l'introduire. -->
    <p class="mt-3 text-sm text-gray-700">
      {{ $t('gnss.etatLibelle') }}
      <strong v-if="rapporte !== null">{{ rapporte ? $t('gnss.actif') : $t('gnss.inactif') }}</strong>
      <span v-else class="text-gray-500">{{ $t('gnss.inconnu') }}</span>
    </p>
    <choix-binaire class="mt-2" :titre="$t('gnss.titre')" :busy="busy" :send="send"
                   :rapporte="device.reported_config && device.reported_config.gnss"
                   :demande="device.gnss_enabled"
                   :label-oui="$t('gnss.optionActif')" :label-non="$t('gnss.optionInactif')"
                   cmd-oui="gnss_enable" cmd-non="gnss_disable" />
    <p class="mt-1 text-xs text-gray-500">{{ $t('gnss.aideEtat') }}</p>

    <div class="mt-4 pt-3 border-t border-gray-100">
      <label class="block text-xs font-medium text-gray-600 mb-1">
        {{ $t('gnss.intervalle') }}
        <span v-if="technique" class="text-gray-400">(sleep post-fix)</span>
      </label>
      <div class="flex items-center gap-3">
        <input type="range" min="15" max="600" step="1" v-model.number="intervalle" class="flex-1" />
        <span class="font-mono text-sm w-14 text-right">{{ intervalle }} s</span>
      </div>
      <valeur-rapportee :rapporte="device.reported_config && device.reported_config.gnss_interval_s"
                        :demande="device.gnss_interval_s" :libelle="v => `${v} s`" />
      <p class="text-xs text-gray-500 mt-1">
        {{ $t('gnss.aide') }}
      </p>
      <button @click="send('set_gnss_interval', { v: intervalle })"
              class="btn btn-primary text-sm mt-2" :disabled="busy">
        {{ $t('gnss.appliquerIntervalle') }}
      </button>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, watch, computed } from 'vue';
import ChoixBinaire, { lireRapporte } from './ChoixBinaire.vue';
import ValeurRapportee from './ValeurRapportee.vue';

export default defineComponent({
  name: 'GnssCard',
  components: { ChoixBinaire, ValeurRapportee },
  props: {
    device:    { type: Object, required: true },
    send:      { type: Function, required: true },
    busy:      { type: Boolean, default: false },
    technique: { type: Boolean, default: false }
  },
  setup(props) {
    const rapporte = computed(() => lireRapporte(props.device.reported_config
      && props.device.reported_config.gnss));

    const intervalle = ref(23);
    watch(() => props.device.gnss_interval_s,
          v => { if (v !== null && v !== undefined) intervalle.value = Number(v); }, { immediate: true });
    return { intervalle, rapporte };
  }
});
</script>
